'use client';
import dynamic from 'next/dynamic';
import { clsx } from 'clsx';
import { OrderCallWrapper } from '@/components/features/OrderCallWrapper/OrderCallWrapper';
import { PhoneLink } from '@/components/ui/PhoneLink/PhoneLink';
import { SvgContacts, SvgTime } from '@/components/icons';
import { MedicalUnit, MedicalUnitScheduleRes } from '@/api/medicalUnits/medicalUnits.types';
import s from './topMenu.module.scss';

const StatusOpen = dynamic(() => import('@/components/ui/StatusOpen/StatusOpen'), { ssr: false });

interface Props {
  schedule: MedicalUnitScheduleRes;
  aboutData: MedicalUnit;
  forBurger?: boolean;
}

export const TopMenu = ({ aboutData, schedule, forBurger }: Props) => {
  const reason = schedule.reason ? ` - ${schedule.reason}` : null;

  return (
    <div className={clsx(s.topMenu, { [s.topMenu_burger]: forBurger })}>
      <div className={`${s.topMenu__container} header-container`}>
        <div className={s.topMenu__contactsWrapper}>
          <div className={s.topMenu__phoneWrapper}>
            <SvgContacts />
            <PhoneLink className={s.phone} phone={aboutData.main_phone} codeIsFour />
          </div>

          {schedule.open_time
            ? (
              <div className={s.topMenu__phoneWrapper}>
                <SvgTime />
                <span className={s.shedule}>
                  с {schedule.open_time} до {schedule.close_time}{reason}
                </span>
                <StatusOpen
                  className={s.topMenu__status}
                  openTime={schedule.open_time}
                  closeTime={schedule.close_time}
                />
              </div>
            )
            : (
              <div className={s.topMenu__phoneWrapper}>
                <SvgTime />
                <span className={s.shedule}>выходной{reason}</span>
              </div>
            )
          }
        </div>

        <OrderCallWrapper className={s.topMenu__buttonWrapper}>
          <button className={`${s.topMenu__button} txt-16-med`}>
            Записаться к нам
          </button>
        </OrderCallWrapper>
      </div>
    </div>
  );
};
